import { deepCopy, sortTheme } from '@/utils'

const dataTable = {
  encodeData: (data) => {
    const { commonInfo, quesShowList, quesTypeShowMap, userAnsMap } = data
    /*
    * 构造大题信息数据对象模型
    * */
    let questionMap = []
    let typeArr = []

    //  添加临时答案
    for(let item in userAnsMap) {
      userAnsMap[item].tempAnswer = ""
    }
    let userAnsMapCopy = deepCopy(userAnsMap)
    let quesTypeShowMapCopy = deepCopy(quesTypeShowMap)

    //对大题进行排序
    for (let key in quesTypeShowMap) {
      typeArr.push(quesTypeShowMap[key])
    }
    typeArr.sort(sortTheme).forEach(item => {
      questionMap.push(item)
      questionMap[questionMap.length - 1].list = []
      questionMap[questionMap.length - 1].hidden = false
    })

    for (let item of quesShowList) {
      let ques = userAnsMapCopy[item.questionID]
      let quesType = quesTypeShowMapCopy[item.relOrder]
      ques.viewTypeName = quesType.viewTypeName
      ques.serialNum = item.serialNum
      if(ques.quesTypeID === 2) ques.userAnswer = ques.userAnswer ? ques.userAnswer.split('') : []  //  多选题设置为数组形式
      let itemChild = item.childQuesIDs
      if (itemChild && itemChild !== 'mixed') {
        //判断是否属于大题套小题
        ques.smallContent = []
        let itemChildArr = itemChild.split(',')
        for (let i = 0; i < itemChildArr.length; i++) {
          ques.smallContent.push(userAnsMapCopy[itemChildArr[i]])
        }
      }
      for (let i = 0; i < questionMap.length; i++) {
        if (questionMap[i].relOrder === item.relOrder) {
          questionMap[i].list.push(ques)
          questionMap[i].quesTypeID = ques.quesTypeID
          break
        }
      }
    }

    //添加试卷整体分数信息
    let submitData = {  //  提交所需数据
      paperScore: 0,  //  试题总分
      allQuesNum: 0,  //  试题类型个数
      allChildQuesNum: 0,  //  所有小题个数
      quesTypeResultList: []  //  试卷类型详细信息
    }

    questionMap.forEach(item => {
      submitData.allQuesNum++
      let arrEle = {
        relOrder: '',
        allQuesNum: 0,
        allChildQuesNum: null,
        quesTypeScore: 0
      }
      arrEle.relOrder = item.relOrder
      item.list.forEach(perQues => {
        let smallContent = perQues.smallContent
        submitData.paperScore += perQues.score
        arrEle.allQuesNum++
        if (smallContent && smallContent.length) {
          smallContent.forEach(smallQues => {
            submitData.allChildQuesNum++
            arrEle.quesTypeScore += smallQues.score
            arrEle.allChildQuesNum++
          })
        } else {
          submitData.allChildQuesNum++
          arrEle.quesTypeScore += perQues.score
        }
      })
      submitData.quesTypeResultList.push(arrEle)
    })
    return {
      commonInfo, quesTypeShowMap, quesShowList, userAnsMap, questionMap, submitData
    }
  }
}
export default dataTable
